import { useFlexFlagIsOn } from '@indeed/flex-feature-flags'
import { Tag } from '@indeed/ifl-components'
import React from 'react'

const IndeedTag = ({ isIndeedAdvertiser }: { isIndeedAdvertiser: boolean }) => {
  const indeedTag = useFlexFlagIsOn('acp_indeed_advertiser_tag')

  if (!indeedTag || !isIndeedAdvertiser) return null
  return <Tag status="info">Indeed Employer</Tag>
}

export default IndeedTag
